import { Avatar, Box, Chip, List, ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { setInspectionSelectedItem } from 'app/actions/transport';
import { Autosizer, Scrollbar } from 'app/components';
import { InspectionIcon } from 'app/icons';
import React, { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FixedSizeList } from 'react-window';

const TransportInspectionList = () => {
  const dispatch = useDispatch();
  const { inspections } = useSelector((state) => state.transport.selectedItem);
  const { inspectionSelectedItem } = useSelector((state) => state.transport);

  const handleItemClick = (value) => dispatch(setInspectionSelectedItem(value));

  return (
    <Box
      component='div'
      sx={(theme) => ({
        width: '100%',
        height: '100%',
        '.simplebar-offset > div': {
          '&::-webkit-scrollbar': {
            width: 0,
          },
          '&::-webkit-scrollbar-track': {
            background: 'transparent',
            boxShadow: 'none',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        },
        '.MuiListItem-root': {
          width: '100%',
          userSelect: 'none',
          padding: theme.spacing(0),
          borderRadius: '0',
          '&.Mui-selected .MuiListItemText-secondary': {
            color: alpha(theme.palette.primary.contrastText, 0.85),
          },
          '.MuiListItemIcon-root': {
            justifyContent: 'end',
            '.MuiCheckbox-root': {
              padding: theme.spacing(0),
              marginRight: theme.spacing(0),
              svg: {
                fontSize: '18px',
              },
            },
          },
          '.MuiListItemAvatar-root': {
            minWidth: '36px',
          },
          '.MuiAvatar-circular': {
            color: theme.palette.primary.main,
            bgcolor: alpha(theme.palette.primary.main, 0.12),
            marginRight: '8px',
            svg: {
              fontSize: '16px',
              path: {
                fill: theme.palette.primary.main,
              },
            },
          },
          '.MuiListItemButton-root': {
            padding: theme.spacing(1, 2),
            borderRadius: '0',
          },
          '.MuiListItemText-root': {
            margin: theme.spacing(0),
          },
          '.MuiChip-root': {
            height: '20px',
            span: {
              fontSize: '10px',
              color: 'white',
            },
          },
        },
      })}>
      <Autosizer>
        {({ height, width }) => (
          <Box sx={{ height, width }}>
            <Scrollbar>
              {({ scrollableNodeRef, contentNodeRef }) => (
                <FixedSizeList
                  height={height}
                  itemSize={47}
                  overscanCount={10}
                  itemCount={inspections.length}
                  innerRef={contentNodeRef}
                  outerRef={scrollableNodeRef}
                  innerElementType={TransportInspectionListInnerElementType}
                  itemData={{
                    items: inspections,
                    selectedItem: inspectionSelectedItem,
                    onClick: handleItemClick,
                  }}>
                  {TransportInspectionListItemRender}
                </FixedSizeList>
              )}
            </Scrollbar>
          </Box>
        )}
      </Autosizer>
    </Box>
  );
};

const TransportInspectionListInnerElementType = forwardRef((props, ref) => <List ref={ref} disablePadding {...props} />);

const TransportInspectionListItemRender = ({ data, index, style }) => {
  const { items, selectedItem, onClick } = data;

  return (
    <ListItem
      key={items[index].id}
      style={style}
      onClick={() => onClick(items[index])}
      selected={selectedItem?.id === items[index].id}
      secondaryAction={
        <Chip
          size='small'
          label={items[index].status ? 'Выезд разрешен' : 'Выезд запрещен'}
          color={items[index].status ? 'success' : 'error'}
        />
      }>
      <ListItemButton>
        <ListItemAvatar>
          <Avatar>
            <InspectionIcon fontSize='small' />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary={items[index].name} secondary={moment(items[index].created_at).format('DD.MM.YYYY HH:mm:ss')} />
      </ListItemButton>
    </ListItem>
  );
};

export default TransportInspectionList;
